/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Hand-added (not regenerated from /api-docs - backend endpoint lives in a parallel session
 * with no live /api-docs yet). Remove this note once a real swagger regen covers it.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AutotagSettingResponse } from '../model/autotagSettingResponse';
import { AutotagSettingUpdateRequest } from '../model/autotagSettingUpdateRequest';
import { AutotagSettingUpdateResponse } from '../model/autotagSettingUpdateResponse';
import { AutotagSettingsDisableAllResponse } from '../model/autotagSettingsDisableAllResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ManagementAutotagSettingsControllerService {

    protected basePath = 'https://contract-notices.sette-services.inellipse.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listAutotagSettings(observe?: 'body', reportProgress?: boolean): Observable<Array<AutotagSettingResponse>>;
    public listAutotagSettings(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AutotagSettingResponse>>>;
    public listAutotagSettings(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AutotagSettingResponse>>>;
    public listAutotagSettings(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<Array<AutotagSettingResponse>>('get',`${this.basePath}/v1/management/autotag-settings`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param key
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAutotagSetting(key: string, body: AutotagSettingUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<AutotagSettingUpdateResponse>;
    public updateAutotagSetting(key: string, body: AutotagSettingUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AutotagSettingUpdateResponse>>;
    public updateAutotagSetting(key: string, body: AutotagSettingUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AutotagSettingUpdateResponse>>;
    public updateAutotagSetting(key: string, body: AutotagSettingUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (key === null || key === undefined) {
            throw new Error('Required parameter key was null or undefined when calling updateAutotagSetting.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateAutotagSetting.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AutotagSettingUpdateResponse>('put',`${this.basePath}/v1/management/autotag-settings/${encodeURIComponent(String(key))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disableAllAutotagSettings(observe?: 'body', reportProgress?: boolean): Observable<AutotagSettingsDisableAllResponse>;
    public disableAllAutotagSettings(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AutotagSettingsDisableAllResponse>>;
    public disableAllAutotagSettings(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AutotagSettingsDisableAllResponse>>;
    public disableAllAutotagSettings(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.request<AutotagSettingsDisableAllResponse>('post',`${this.basePath}/v1/management/autotag-settings/disable-all`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
